import { authService } from '@/features/auth/model/auth-service';
import type { HeaderData, UserProfileData } from './types';

function computeInitials(name: string): string {
	const parts = name.trim().split(/\s+/).filter(Boolean);
	if (parts.length === 0) return '';
	if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * Hook to provide header data (user profile) sourced from the MSAL account.
 *
 * Role is not exposed by the MSAL AccountInfo; populate it via app roles / claims
 * or a backend profile endpoint when that becomes available.
 */
export function useHeaderData(): HeaderData {
	const account = authService.getCurrentUser();
	const name = account?.name ?? account?.username ?? 'Unknown User';

	const user: UserProfileData = {
		name,
		role: '',
		initials: computeInitials(name),
	};

	return { user };
}
